let API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "" // In dev, requests go through the CRA proxy (see setupProxy.js)
    : "https://fb.dataklout.com"; // Production fallback

export const initializeConfig = async () => {
  // In development, skip config.json so requests go through the CRA proxy
  if (process.env.NODE_ENV === "development") return;
  try {
    const response = await fetch("/config.json");
    const data = await response.json();
    API_BASE_URL = data.API_BASE_URL || API_BASE_URL;
  } catch (error) {
    console.error("Failed to load config, using default:", error);
  }
};

const config = {
  get API_BASE_URL() {
    return API_BASE_URL;
  },
};

export default config;
